import { isNotNil } from './object-util'
import { isValidNumberString } from './number-util'

const specialSymbols = ['-', '=', '@', '+', '"', '\t']

// Excel runs a cell that starts with a special symbol as a formula, so the
// cell is escaped with a single quote.
function formatToValidItems(item: string | undefined) {
  if (typeof item === 'string') {
    if (isValidNumberString(item)) {
      return item
    }

    if (specialSymbols.some((x) => item.startsWith(x))) {
      return `'${item}`
    }
  }

  return item
}

function quoteItem(item: string | undefined) {
  return isNotNil(item) ? `"${item.replaceAll('"', '""')}"` : ''
}

/**
 * Rows of cells. An `undefined` cell is left empty.
 */
export type CSVData = (string | undefined)[][]

/**
 * Downloads the data as a CSV file.
 *
 * @param csvData
 * @param filename
 */
export function csvDownload(csvData: CSVData, filename: string) {
  const csv = csvData
    .map((innerArray) =>
      innerArray.map((item) => quoteItem(formatToValidItems(item))).join(','),
    )
    .join('\n')

  const csvBlob = new Blob([csv], {
    type: 'text/csv',
  })

  const link = document.createElement('a')
  link.download = filename
  link.href = URL.createObjectURL(csvBlob)
  link.style.display = 'none'

  document.body.appendChild(link)

  link.click()

  setTimeout(() => {
    URL.revokeObjectURL(link.href)
    link.parentNode?.removeChild(link)
  }, 0)
}
